import React, { useState } from 'react';
import { ArrowUp, ArrowDown, Link, Maximize2 } from 'lucide-react';

const ToolsPicker = ({ canvasWidth, canvasHeight, onCanvasSizeChange }) => {
  const [localCanvasWidth, setLocalCanvasWidth] = useState(canvasWidth || 1080);
  const [localCanvasHeight, setLocalCanvasHeight] = useState(canvasHeight || 1080);

  const handleCanvasSizeChange = (width, height) => {
    setLocalCanvasWidth(width);
    setLocalCanvasHeight(height);
    onCanvasSizeChange && onCanvasSizeChange({ width, height });
  };

  const presetSizes = [
    { name: 'Square', width: 1080, height: 1080 },
    { name: 'Portrait', width: 1080, height: 1350 },
    { name: 'Landscape', width: 1350, height: 1080 }
  ];

  return (
    <div className="space-y-4">
      {/* Arrange Section */}
      <div>
        <h3 className="text-gray-300 text-xs font-medium mb-2 uppercase tracking-wide">Arrange</h3>
        
        <div className="grid grid-cols-2 gap-1 mb-2">
          <button className="flex items-center justify-center gap-2 px-3 py-2 text-gray-300 hover:bg-gray-600 rounded transition-colors text-xs" style={{ backgroundColor: '#4a4a4a' }}>
            <ArrowUp size={12} />
            To Front
          </button>
          <button className="flex items-center justify-center gap-2 px-3 py-2 text-gray-300 hover:bg-gray-600 rounded transition-colors text-xs" style={{ backgroundColor: '#4a4a4a' }}>
            <ArrowDown size={12} />
            To Back
          </button>
        </div>

        <div className="grid grid-cols-2 gap-1">
          <button className="flex items-center justify-center gap-2 px-3 py-2 text-gray-300 hover:bg-gray-600 rounded transition-colors text-xs" style={{ backgroundColor: '#4a4a4a' }}>
            <ArrowUp size={10} />
            Forward
          </button>
          <button className="flex items-center justify-center gap-2 px-3 py-2 text-gray-300 hover:bg-gray-600 rounded transition-colors text-xs" style={{ backgroundColor: '#4a4a4a' }}>
            <ArrowDown size={10} />
            Backward
          </button>
        </div>
      </div>

      {/* Divider */}
      <div className="w-full h-px bg-gray-600"></div>

      {/* Canvas Size Section */}
      <div>
        <h3 className="text-gray-300 text-xs font-medium mb-3 uppercase tracking-wide">Canvas Size</h3>
        
        {/* Width and Height Inputs */}
        <div className="grid grid-cols-2 gap-2 mb-3">
          <div>
            <label className="block text-gray-400 text-xs mb-1">W</label>
            <input
              type="number"
              value={localCanvasWidth}
              onChange={(e) => handleCanvasSizeChange(parseInt(e.target.value) || 1080, localCanvasHeight)}
              className="w-full bg-gray-700 text-gray-300 px-2 py-2 rounded border-none text-sm"
              style={{ backgroundColor: '#4a4a4a', fontSize: '14px' }}
              placeholder="1080 px"
            />
          </div>
          <div>
            <label className="block text-gray-400 text-xs mb-1">H</label>
            <input
              type="number"
              value={localCanvasHeight}
              onChange={(e) => handleCanvasSizeChange(localCanvasWidth, parseInt(e.target.value) || 1080)}
              className="w-full bg-gray-700 text-gray-300 px-2 py-2 rounded border-none text-sm"
              style={{ backgroundColor: '#4a4a4a', fontSize: '14px' }}
              placeholder="1080 px"
            />
          </div>
        </div>

        {/* Preset Size Buttons */}
        <div className="grid grid-cols-3 gap-1 mb-3">
          {presetSizes.map((preset) => (
            <button
              key={preset.name}
              onClick={() => handleCanvasSizeChange(preset.width, preset.height)}
              className="px-2 py-2 text-gray-300 hover:bg-gray-600 rounded transition-colors text-xs"
              style={{ backgroundColor: '#4a4a4a' }}
            >
              {preset.name}
            </button>
          ))}
        </div>

        {/* Action Buttons */}
        <div className="grid grid-cols-2 gap-1">
          <button className="flex items-center justify-center gap-2 px-3 py-2 text-gray-300 hover:bg-gray-600 rounded transition-colors text-xs" style={{ backgroundColor: '#4a4a4a' }}>
            <Link size={12} />
            Link
          </button>
          <button className="flex items-center justify-center gap-2 px-3 py-2 text-gray-300 hover:bg-gray-600 rounded transition-colors text-xs" style={{ backgroundColor: '#4a4a4a' }}>
            <Maximize2 size={12} />
            Fit (⌘/Ctrl+0)
          </button>
        </div>
      </div>
    </div>
  );
};

export default ToolsPicker;
